import React from 'react';
import api from '../api/axiosConfig';
import PdfViewerModal from '../components/PdfViewerModal';
import { showErrorAlert } from '../utils/alert';

import './ServicePage.css';
import './LaporanPage.css';

const LaporanPage = () => {
  // --- PERBAIKAN ADA DI SINI ---
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const [unitKerja, setUnitKerja] = React.useState('Dukungan Staf Khusus Presiden');
  const [bulan, setBulan] = React.useState(currentMonth);
  const [tahun, setTahun] = React.useState(currentYear);
  const [laporan, setLaporan] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  
  const [pdfUrl, setPdfUrl] = React.useState(null);
  const [isViewerOpen, setViewerOpen] = React.useState(false);

  const handleCariData = async (e) => {
    e.preventDefault();
    if (!laporan) {
      showErrorAlert('Silakan pilih jenis laporan terlebih dahulu.');
      return;
    }
    setLoading(true);
    setPdfUrl(null);

    try {
      const response = await api.post('/api/laporan/generate', 
        { unitKerja, bulan, tahun, laporan },
        { responseType: 'blob' }
      );
      
      const file = new Blob([response.data], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      
      setPdfUrl(fileURL);
      setViewerOpen(true);
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        const errorText = await error.response.data.text();
        const errorJson = JSON.parse(errorText);
        showErrorAlert(errorJson.message || 'Terjadi kesalahan pada server.');
      } else {
        showErrorAlert(error.response?.data?.message || 'Gagal membuat laporan.');
      }
    } finally {
      setLoading(false);
    }
  };

  const generateYearOptions = () => {
    const years = [];
    for (let i = 0; i < 5; i++) {
      years.push(currentYear - i);
    }
    return years.map(year => <option key={year} value={year}>{year}</option>);
  };
  
  const monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

  return (
    <>
      <div className="page-container">
        <div className="page-header">
          <p>Dashboard / Laporan</p>
          <h1>Cetak Laporan</h1>
        </div>
        <div className="content-card">
          <form onSubmit={handleCariData} className="report-form-container">
            <div className="form-group">
              <label>Unit Kerja</label>
              <select value={unitKerja} onChange={(e) => setUnitKerja(e.target.value)}>
                <option value="Dukungan Staf Khusus Presiden">Dukungan Staf Khusus Presiden</option>
                <option value="Biro Administrasi">Biro Administrasi</option>
              </select>
            </div>

            <div className="form-group">
                <label>Laporan</label>
                <select value={laporan} onChange={(e) => setLaporan(e.target.value)} required>
                  <option value="">-- Pilih Laporan --</option>
                  <option value="kendaraan">Laporan Data Kendaraan</option>
                  <option value="pengguna_kendaraan">Laporan Pengguna Kendaraan</option>
                  <option value="jadwal_servis">Laporan Jadwal Servis</option>
                  <option value="riwayat_servis">Laporan Riwayat Servis</option>
                </select>
              </div>
            
            <div className="date-filter-group">
              <div className="form-group">
                <label>Bulan</label>
                <select value={bulan} onChange={(e) => setBulan(e.target.value)}>
                  {monthNames.map((name, index) => (
                    <option key={index + 1} value={index + 1}>{name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Tahun</label>
                <select value={tahun} onChange={(e) => setTahun(e.target.value)}>
                  {generateYearOptions()}
                </select>
              </div>
            </div>

            <div className="report-actions">
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Membuat...' : 'Cari Data'}
              </button>
            </div>
          </form>
        </div>
      </div>
      
      <PdfViewerModal
        show={isViewerOpen}
        onClose={() => {
            setViewerOpen(false);
            if (pdfUrl) URL.revokeObjectURL(pdfUrl);
        }}
        fileUrl={pdfUrl}
        size="large"
      />
    </>
  );
};

export default LaporanPage;